<template>
	<div class="service-group">
		<template v-if="loading">
			<div class="service-group-item" v-for="v in 5" :key="5">
				<van-skeleton avatar :row="3" />
			</div>
		</template>
		<template v-else>
			<template v-if="type === 1">
				<div class="service-group-item" v-if="myService.length">
					<div class="service-group-header">
						<div class="service-group-name">常用微服务（{{ myService.length }}）</div>
					</div>
					<div class="service-list">
						<div class="service-item" v-for="service in myService" :key="service.id">
							<img
								class="service-icon"
								:src="service.imgs ? config.imgUrl + service.imgs : defaultImg"
								alt=""
							/>
							<div class="name-wrap" @click="toService(service)">
								<div class="name" v-html="heightLightName(service.name)"></div>
								<!--<div class="extra-name">别名：-</div>-->
							</div>
							<img
								v-if="service.star"
								@click="editMyService(service)"
								class="star"
								src="@/assets/img/star-checked.png"
								alt=""
							/>
							<img
								v-else
								class="star"
								@click="editMyService(service)"
								src="@/assets/img/star.png"
								alt=""
							/>
						</div>
					</div>
				</div>
				<XEmpty v-else type="search" />
			</template>
			<template v-if="type === 0">
				<template v-if="service.length">
					<div
						class="service-group-item"
						v-for="v in service"
						:key="v.id"
						:style="{ display: v.data.length ? 'block' : 'none' }"
					>
						<div class="service-group-header" v-if="v.data.length">
							<div class="service-group-name">{{ v.name }}（{{ v.data.length }}）</div>
						</div>
						<div class="service-list" v-if="v.data.length">
							<template v-for="(service, serviceIndex) in v.data" :key="service.id">
								<div class="service-item" v-if="serviceIndex <= 3 || v.showMore">
									<img
										class="service-icon"
										:src="service.imgs ? config.imgUrl + service.imgs : defaultImg"
										alt=""
									/>
									<div class="name-wrap" @click="toService(service)">
										<div class="name" v-html="heightLightName(service.name)"></div>
										<!--<div class="extra-name">别名：-</div>-->
									</div>
									<img
										v-if="service.star"
										@click="editMyService(service)"
										class="star"
										src="@/assets/img/star-checked.png"
										alt=""
									/>
									<img
										v-else
										class="star"
										@click="editMyService(service)"
										src="@/assets/img/star.png"
										alt=""
									/>
								</div>
							</template>
						</div>
						<div
							class="show-more"
							v-if="!v.showMore && v.data.length > 4"
							@click="v.showMore = true"
						>
							查看更多 <van-icon name="arrow-down" />
						</div>
						<div
							class="show-more"
							v-if="v.showMore && v.data.length > 4"
							@click="v.showMore = false"
						>
							收起 <van-icon name="arrow-up" />
						</div>
					</div>
				</template>
				<XEmpty v-else type="search" />
			</template>
		</template>

		<van-overlay :show="showDetail" :z-index="10">
			<div class="detail-panel-wrap">
				<div class="detail-panel">
					<img src="@/assets/img/commonLayout/topWeaveBg.png" alt="" class="header-bg" />
					<div class="service-name">{{ detail.name }}</div>
					<div class="inner-wrap">
						<div class="service-desc-wrap">
							<div class="name">服务对象</div>
							<div class="desc">学生、教职工</div>
						</div>
						<div class="service-desc-wrap">
							<div class="name">所属部门</div>
							<div class="desc">-</div>
						</div>
						<div class="service-desc-wrap">
							<div class="name">服务开放时间</div>
							<div class="desc">-</div>
						</div>
						<div class="service-desc-wrap">
							<div class="name">服务说明</div>
							<div class="desc detail-desc">-</div>
						</div>
					</div>
					<div @click="toService" class="enter-btn">进入服务</div>
				</div>
				<img @click="closeDesc" class="close-btn" src="@/assets/img/closeCircle.png" alt="" />
			</div>
		</van-overlay>
	</div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/store/auth'
import { appServiceMenuAPI, editMyAppServiceMenuAPI, myAppServiceMenuAPI } from '@/api'
import { config } from '@/config'
import defaultImg from '@/assets/img/service/bg.png'
import XEmpty from '@/components/XEmpty.vue'
import { openWebview } from '@/utils'

const props = defineProps<{
	disabledLoadList?: boolean
	filter: any
}>()

const router = useRouter()
const type = computed(() => props.filter.type)
const loading = ref(false)
const service = ref([])
const myService = ref([])
const showDetail = ref(false)
const detail = ref({})

watch(
	() => props.filter.keyWords,
	async () => {
		await fetchMyList()
		fetchList()
	}
)

watch(
	() => props.filter.cateStrList,
	async () => {
		await fetchMyList()
		fetchList()
	}
)

const heightLightName = (str) => {
	if (!props.filter.keyWords) {
		return str
	}
	const reg = new RegExp(props.filter.keyWords)
	const heightLightStrList = str.match(reg)
	if (heightLightStrList && heightLightStrList.length) {
		const heightLightStr = heightLightStrList[0]
		const otherStrList = str.split(props.filter.keyWords)
		return `
      <span>${otherStrList[0]}</span>
      <span style="color: #BD3A36">${heightLightStr}</span>
      <span>${otherStrList[1]}</span>
    `
	}
	return str
}

const fetchList = async () => {
	try {
		const userStore = useAuthStore()
		try {
			loading.value = true
			const res = await appServiceMenuAPI({
				userName: userStore.userInfo.F_UserId,
				tenantId: '1a1cb2b893d34fcea1d041681f6c9586'
			})
			loading.value = false
			const resData = res.data || {}
			const starIdList = myService.value.map((v) => v.id)
			resData.list.forEach((v) => {
				v.showMore = false
				if (v.data && v.data.length) {
					v.data.forEach((s) => {
						s.star = starIdList.includes(s.id)
					})
				}
				if (props.filter.keyWords) {
					v.data = v.data ? v.data.filter((_v) => _v.name.includes(props.filter.keyWords)) : []
				}
			})
			service.value = resData.list || []
			if (props.filter.cateStrList && props.filter.cateStrList.length) {
				service.value = service.value.filter((_v) => props.filter.cateStrList.includes(_v.name))
			}
		} catch (e) {
			loading.value = false
			console.log(e)
		}
	} catch (e) {
		console.log(e)
	}
}

const fetchMyList = async () => {
	try {
		const userStore = useAuthStore()
		try {
			loading.value = true
			const res = await myAppServiceMenuAPI({
				userName: userStore.userInfo.F_UserId,
				tenantId: '1a1cb2b893d34fcea1d041681f6c9586'
			})
			loading.value = false
			const resData = res.data || {}
			// if (props.filter.keyWords) {
			// 	resData.list = (resData.list || []).filter((_v) => _v.name.includes(props.filter.keyWords))
			// }
			myService.value = (resData.list || []).map((v) => {
				v.star = true
				return v
			})
		} catch (e) {
			loading.value = false
			console.log(e)
		}
	} catch (e) {
		console.log(e)
	}
}

const editMyService = async (service: any) => {
	// 获取所有已经收藏菜单ID列表
	const starIdList = myService.value.map((v) => v.id)
	if (starIdList.includes(service.id)) {
		// 如果当前点击的菜单已经在收藏菜单里面，则删除
		const i = starIdList.findIndex((v) => v === service.id)
		starIdList.splice(i, 1)
		myService.value.splice(i, 1)
	} else {
		starIdList.push(service.id)
		myService.value.push(service)
	}
	const serviceId = starIdList.join(',')
	const userStore = useAuthStore()
	try {
		// loading.value = true
		await editMyAppServiceMenuAPI({
			userName: userStore.userInfo.F_UserId,
			tenantId: '1a1cb2b893d34fcea1d041681f6c9586',
			serviceId: serviceId
		})
		service.star = !service.star
		// loading.value = false
		// await fetchMyList()
		// fetchList()
	} catch (e) {
		await fetchMyList()
		fetchList()
		loading.value = false
		console.log(e)
	}
}

const closeDesc = () => {
	showDetail.value = false
	detail.value = {}
}

const openDesc = (row) => {
	showDetail.value = true
	detail.value = row
}

const toService = (row) => {
	openWebview({
		url: row.links,
		title: row.name
	})
	// router.push({
	// 	path: '/layout/application-page',
	// 	query: {
	// 		link: detail.value.links,
	// 		title: detail.value.name
	// 	}
	// })
	closeDesc()
}

onMounted(async () => {
	if (!props.disabledLoadList) {
		await fetchMyList()
		fetchList()
	}
})
</script>

<style scoped lang="scss">
.service-group {
	width: 100%;
	display: flex;
	flex-direction: column;
	padding-bottom: 60px;
	.service-group-item {
		margin-top: 25px;
	}
	.detail-panel-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		height: 100%;
		.detail-panel {
			width: 295px;
			height: 452px;
			display: flex;
			flex-direction: column;
			background-color: #fff;
			border-radius: 5px 5px 5px 5px;
			padding-bottom: 20px;
			box-sizing: border-box;
			.header-bg {
				width: 100%;
			}
			> .service-name {
				text-align: center;
				font-weight: 500;
				font-size: 16px;
				color: #090d10;
				font-style: normal;
				text-transform: none;
				margin-top: -12px;
			}
			> .enter-btn {
				width: 255px;
				height: 30px;
				background: $primaryColor;
				border-radius: 5px 5px 5px 5px;
				font-weight: 500;
				font-size: 14px;
				color: #ffffff;
				font-style: normal;
				text-transform: none;
				margin: 20px auto 0;
				display: flex;
				align-items: center;
				justify-content: center;
				line-height: 16px;
			}
			> .inner-wrap {
				overflow-y: auto;
				height: 330px;
				.service-desc-wrap {
					padding: 0 20px;
					box-sizing: border-box;
					display: flex;
					flex-direction: column;
					margin-top: 20px;
					> .name {
						font-weight: 400;
						font-size: 14px;
						color: #333333;
						line-height: 16px;
						font-style: normal;
						text-transform: none;
					}
					> .desc {
						font-weight: 400;
						font-size: 12px;
						color: #6d6d6d;
						line-height: 14px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-top: 8px;
					}
					> .detail-desc {
						font-size: 10px;
						line-height: 18px;
					}
				}
			}
		}
		.close-btn {
			width: 32px;
			margin-top: 10px;
		}
	}
	.service-group-header {
		width: 100%;
		font-weight: 500;
		font-size: 16px;
		color: #424649;
		line-height: 19px;
		text-align: left;
		font-style: normal;
		text-transform: none;
		border-bottom: 1px solid #f4f3f3;
		display: flex;
		align-items: center;
		padding-left: 15px;
		.service-group-name {
			padding-bottom: 10px;
			border-bottom: 2px solid #bd3a36;
		}
	}
	.service-list {
		display: flex;
		box-sizing: border-box;
		flex-wrap: wrap;
		padding-left: 5px;
		.service-item {
			border-radius: 5px;
			border: 1px solid #e4e5e7;
			padding: 10px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			margin-top: 15px;
			margin-left: 10px;
			width: 170px;
			.service-icon {
				width: 36px;
				height: 36px;
				flex-shrink: 0;
			}
			.name-wrap {
				margin-left: 6px;
				flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				font-weight: 400;
				font-size: $miniFontSize;
				color: #090d10;
				line-height: 16px;
				text-align: left;
				font-style: normal;
				text-transform: none;
				flex-wrap: wrap;
				.name {
					display: flex;
					align-items: center;
					flex-wrap: wrap;
					> span {
						margin: 0;
						padding: 0;
						line-height: 0;
					}
				}
				.extra-name {
					font-weight: 400;
					font-size: 11px;
					color: #7d7e80;
					line-height: 18px;
					margin-top: 5px;
				}
			}
			.star {
				flex-shrink: 0;
				width: 16px;
			}
		}
	}
	.show-more {
		width: 345px;
		margin: 15px auto;
		background: #f4f3f3;
		border-radius: 2px;
		font-weight: 400;
		font-size: $smallFontSize;
		line-height: 22px;
		color: #7d7e80;
		text-align: center;
		font-style: normal;
		text-transform: none;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 8px 0;
	}
}
</style>
